<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ER0xz/tc-custom/9780226772929.jpg?1730578246130" alt="This image is the cover for the book Rare Coin Score, The Parker Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rare Coin Score, The Parker Novels
      </h1>
      <p class="bookDescription body article font2">
        <p>When it comes to heists, Parker believes in some cardinal rules. On this job, he breaks two of them: never bring a dame along—especially not one you like—and never, ever, work with amateurs. Nevertheless, with the help of a creepy coin collector named Billy, and the lure of a classy widow, he agrees to set up a heist of a coin convention. But Billy’s a rookie with no idea how to pull off a score, and the lady soon becomes a major distraction. <i>The Rare Coin Score</i> marks the first appearance of Claire, who pulls off her own heist on Parker's heart—while together they steal two million dollars worth of coins.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard Stark, Luc Sante
      </h2>
      
      <p class="authorDescription body article"><B>Richard Stark</B> was one of the many pseudonyms of Donald E. Westlake (1933-2008), a prolific author of noir crime fiction. In 1993 the Mystery Writers of America bestowed the society’s highest honor on Westlake, naming him a Grand Master.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0fc8ddf1